// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bloquea scroll cuando hay loading */
body.bm-loading-open { overflow: hidden; }

/* Overlay que cubre toda la pantalla, centra el spinner y apaga el fondo */
.bm-loading-overlay {
  position: fixed;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  background: transparent;    /* <- antes rgba(0,0,0,.35) */
  backdrop-filter: none;       /* <- sin blur */
}

.bm-loading-overlay.visible { display: flex; }

/* Spinner CSS (fallback si no hay Angular Material) */
.css-spinner {
  width: 64px; height: 64px;
  border: 6px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: bmSpin .8s linear infinite;
}

@keyframes bmSpin { to { transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./common/loadingSpinner/loadingSpinnerStyles.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC,uBAAuB,gBAAgB,EAAE;;AAEzC,2EAA2E;AAC3E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uBAAuB,KAAK,6BAA6B;EACzD,qBAAqB,QAAQ,gBAAgB;AAC/C;;AAEA,8BAA8B,aAAa,EAAE;;AAE7C,sDAAsD;AACtD;EACE,WAAW,EAAE,YAAY;EACzB,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,oBAAoB,KAAK,yBAAyB,EAAE,EAAE","sourcesContent":["/* Bloquea scroll cuando hay loading */\nbody.bm-loading-open { overflow: hidden; }\n\n/* Overlay que cubre toda la pantalla, centra el spinner y apaga el fondo */\n.bm-loading-overlay {\n  position: fixed;\n  inset: 0;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  background: transparent;    /* <- antes rgba(0,0,0,.35) */\n  backdrop-filter: none;       /* <- sin blur */\n}\n\n.bm-loading-overlay.visible { display: flex; }\n\n/* Spinner CSS (fallback si no hay Angular Material) */\n.css-spinner {\n  width: 64px; height: 64px;\n  border: 6px solid rgba(255,255,255,0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: bmSpin .8s linear infinite;\n}\n\n@keyframes bmSpin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
